import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {inject} from '@angular/core';
import {OfferService} from '../../service/offer.service';
import {rxMethod} from '@ngrx/signals/rxjs-interop';
import {exhaustMap} from 'rxjs';
import {tap} from 'rxjs/operators';
import {defaultSalesPageSettings, SalesPageSettings} from '../../model/sales-page-settings.model';
import {SpinnerService} from '../../service/spinner.service';
import {SalesOfferState} from './sales-offer-state.model';
import {updateOfferBidDataDealerSpecific, updateOfferBidDataGeneral} from '../common-state-functions';
import {SearchService} from '../../service/search.service';

export const CurrentUserOfferSignalStore = signalStore(
  {providedIn: 'root'},
  withState({
    offers: [] as OfferDto[],
    totalElements: 0 as number,
    totalPages: 0 as number,
    pageSettings: defaultSalesPageSettings,
    searchAggregation: undefined as VehicleOfferSearchAggregation,
    searchParams: {} as VehicleOfferSearchParams,
    offersInitInfo: undefined
  } as SalesOfferState),
  withMethods((store, offerService = inject(OfferService), spinnerService = inject(SpinnerService), searchService= inject(SearchService)) => ({
    fetchOffers: rxMethod<void>(
      exhaustMap(() => {
        return spinnerService.spinner(offerService.getCurrentUserCompanyOffers(store.pageSettings(),store.searchParams())).pipe(
          tap((page) => {
            patchState(store, {offers: page.content, totalElements: page.totalElements, totalPages: page.totalPages});
            patchState(store, {offersInitInfo: 'fetchOffers-page-' + store.pageSettings().page + '-sort-order-' + store.pageSettings().sort + '-' + store.pageSettings().order});
          })
        );
      })
    ),
    fetchSearchAggregations: rxMethod<void>(
      exhaustMap(() => {
        return searchService.getSearchAggregations().pipe(tap(aggregations => {
          patchState(store, {searchAggregation: aggregations});
        }));
      })
    ),
    updatePageSettings(pageSettings: SalesPageSettings): void {
      patchState(store, {pageSettings: pageSettings});
      this.fetchOffers();
    },
    updateSearchParams(searchParams: VehicleOfferSearchParams): void {
      patchState(store, {searchParams: searchParams});
      this.fetchOffers();
    },
    updateSearchAggregation(searchAggregation: VehicleOfferSearchAggregation): void {
      patchState(store, {searchAggregation: searchAggregation});
    },
    updateOfferBidsGeneral(bidUpdate: BidGeneralStatusDto): void {
      const offerToUpdate = structuredClone(store.offers().find(offer => offer.id === bidUpdate.offerId));
      updateOfferBidDataGeneral(offerToUpdate, bidUpdate);
      patchState(store, {offers: store.offers().map(offer => offer.id === offerToUpdate.id ? offerToUpdate : offer)});
    },
    updateOfferBidsDealerSpecific(bidUpdate: BidDealerStatusDto): void {
      const offerToUpdate = structuredClone(store.offers().find(offer => offer.id === bidUpdate.generalStatusDto.offerId));
      updateOfferBidDataDealerSpecific(offerToUpdate, bidUpdate);
      patchState(store, {offers: store.offers().map(offer => offer.id === offerToUpdate.id ? offerToUpdate : offer)});
    }
  }))
);
